export const L10N = {
  LABEL_REDIRECTING: { id: 'core.label.redirecting', defaultMessage: 'Redirecting…' },
};
